// extracted by mini-css-extract-plugin
module.exports = {"question":"Question_question__1QLS5","qtitle":"Question_qtitle__2R_LO"};